export const home = {
  // Hero Section
  heroTitle: 'Maximize the Quality',
  heroTitleHighlight: 'of Language Exchange',
  heroSubtitle: 'Quality 1-on-1 Language Exchange Service',
  heroDescription: 'EachTeach is a platform that provides opportunities for language learning with native speakers through structured worksheets online. Our paid, one-on-one language exchange creates a secure and safe learning environment. By matching you with partners suited to your language learning level, conversations become challenging yet highly intensive learning experiences. It\'s okay to make mistakes. An environment rich with opportunities to challenge yourself dramatically improves language learning efficiency.',
  getStarted: 'Register Now',
  learnMore: 'View Course Flow',
  
  // Features
  feature1Title: 'Safe Paid System',
  feature1Description: 'Completely avoid unwanted interactions. An environment where only serious learners gather.',
  feature2Title: 'Optimal Matching',
  feature2Description: 'Paired with partners at different learning levels. The optimal stress level that accelerates your growth.',
  feature3Title: 'Dramatic Efficiency Boost',
  feature3Description: 'Many opportunities to explain your native language in the target language, rapidly improving practical skills.',
  
  // Lesson Content Section
  lessonContentTitle: 'Lesson Content',
  lessonContentSubtitle: 'Comprehensive lesson environment to support efficient learning',
  
  freeTrial: 'First 2 Lessons Free',
  freeTrialDescription: 'Simply answer pre and post-lesson surveys to get your first 2 lessons completely free!',
  
  googleMeetTitle: 'Online Lessons via Google Meet',
  googleMeetDescription: 'Take lessons from anywhere in a comfortable environment.',
  
  worksheetTitle: 'Thoughtfully Designed Worksheets',
  worksheetDescription: 'Lessons progress along carefully designed worksheets aimed at conversation support and maintaining learning efficiency. Feel free to write on them or print them as long as you don\'t repurpose them! Use them to enhance your learning.',
  
  communicationTitle: 'Real Communication Skills',
  communicationDescription: 'During lessons, make use of translation tools, AI, and chat functions - experience how efforts to communicate translate to real conversations. Develop true communication skills through mutual understanding.',
  
  // Flow Steps
  flowStep1: 'Connect via\nGoogle Meet',
  flowStep2: 'Follow\nWorksheet',
  flowStep3: 'Use Translation\n& AI Tools',
  flowStep4: 'Improve\nPractical Skills',
  
  // Pricing Section
  pricingTitle: 'Pricing Plans',
  pricingSubtitle: 'Different pricing based on learning language and nationality. Additional Lessons are 1.2x the regular lesson price.',
  
  regularLessons: 'Regular Lessons (Levels A-C)',
  englishLearning: 'English Learning',
  forJapanese: 'For Japanese',
  forKorean: 'For Korean',
  japaneseKoreanLearning: 'Japanese/Korean Learning',
  allLearners: 'All Learners',
  perLesson: 'Per lesson (90 min)',
  
  additionalLessons: 'Additional Lessons (Advanced Courses)',
  englishLearningJapanese: 'English Learning (Japanese)',
  englishLearningKorean: 'English Learning (Korean)',
  additionalLessonsNote: 'Additional Lessons are available after completing regular lessons (Levels A-C).',
  
  extraLessonsTitle: 'Extra Lessons (Level Advancement)',
  extraLessonsDescription: 'When advancing to each level, you\'ll take an Extra Lesson set consisting of 1 test and 2 reinforcement lessons. The price is equivalent to 3 regular lessons.'
};
